import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t border-gold/20 bg-black">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="text-3xl font-playfair font-bold mb-4">
              <span className="text-gold">M</span>ichael <span className="text-gold">E</span>dwards
            </div>
            <p className="text-gray-400 text-sm">
              Michael Edwards Media
            </p>
          </div>
          
          {/* Navigation */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gold">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-white transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('work')} className="text-gray-400 hover:text-white transition-colors">
                  Work
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('production-pricing')} className="text-gray-400 hover:text-white transition-colors">
                  Production & Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-gold">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:michdefancis@gmail.com" className="text-gray-400 hover:text-white transition-colors">
                  michdefancis@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:6318045606" className="text-gray-400 hover:text-white transition-colors">
                  (631) 804-5606
                </a>
              </li>
              <li className="pt-2">
                <a 
                  href="https://instagram.com/michaeledwards.media" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-400 hover:text-magenta transition-colors"
                >
                  <Instagram size={20} />
                  <span>@michaeledwards.media</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <p>© {new Date().getFullYear()} Michael Edwards Media. All rights reserved.</p>
          <p>Visual Storytelling & Creative Production</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;